import { render } from "./ModalCreateEditNews.vue?vue&type=template&id=cb976050&scoped=true&ts=true"
import script from "./ModalCreateEditNews.vue?vue&type=script&lang=ts"
export * from "./ModalCreateEditNews.vue?vue&type=script&lang=ts"

import "./ModalCreateEditNews.vue?vue&type=style&index=0&id=cb976050&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb976050"]])

export default __exports__